/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationItemModel } from '../../models/organization-item-model';

export interface DashboardOrganizationListGet$Params {
}

export function dashboardOrganizationListGet(http: HttpClient, rootUrl: string, params?: DashboardOrganizationListGet$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<Array<OrganizationItemModel>>> {
  const rb = new RequestBuilder(rootUrl, dashboardOrganizationListGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<Array<OrganizationItemModel>>;
    })
  );
}

dashboardOrganizationListGet.PATH = '/Dashboard/OrganizationList';
